import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedArticles() {
  const latestArticles = articles.slice(0, 6);
  const hotArticles = articles.slice(6, 12);

  return (
    <section className="bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                最新文章
              </h2>
              <Link
                to="/category/movie-news"
                className="flex items-center text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
              >
                更多
                <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                热门推荐
              </h2>
            </div>
            <div className="space-y-1">
              {hotArticles.map((article, index) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="flex items-start gap-3 p-3 rounded-lg hover:bg-background-200/60 transition-colors duration-200 cursor-pointer group"
                >
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center text-xs font-bold">
                    {index + 1}
                  </span>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                      {article.title}
                    </h4>
                    <div className="flex items-center mt-1.5 text-xs text-foreground-400 space-x-3">
                      <span>{article.category}</span>
                      <span>{article.viewCount.toLocaleString()} 阅读</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            <div className="mt-8 p-5 rounded-lg bg-accent-50 border border-accent-100">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center">
                  <i className="ri-fire-line text-white text-sm"></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-900">热门标签</h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {['国产电影', '科幻', 'Netflix', '动画', '宫崎骏', '韩剧', '票房', '流媒体', '国产剧', '吉卜力'].map((tag) => (
                  <Link
                    key={tag}
                    to={`/category/movie-news`}
                    className="px-3 py-1.5 rounded-full text-xs bg-white border border-background-200 text-foreground-600 hover:text-primary-500 hover:border-primary-200 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {tag}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}